export class HospitalizedPatientDetailsModel { 
    client_no:number
    last_name:string
    first_name:string
    tag_no:number
    pet_no:number
    pet_name:string	
    sex:string	
    weight:number	
    specie_name:string	
    breed_name:string	
    color_name:string	
    req_date:string	
    link_no:number	
    link_type:number	
    status:string	
    unit:number	
    cost:number

    constructor( 
        client_no:number,
        last_name:string,
        first_name:string,
        tag_no:number,
        pet_no:number,
        pet_name:string,	
        sex:string,	
        weight:number,	
        specie_name:string,	
        breed_name:string,	
        color_name:string,	
        req_date:string,	
        link_no:number,	
        link_type:number,	
        status:string,	
        unit:number,	
        cost:number
    ) {
        this.client_no = client_no
        this.last_name = last_name
        this.first_name = first_name
        this.tag_no = tag_no
        this.pet_no = pet_no
        this.pet_name = pet_name
        this.sex = sex
        this.weight = weight
        this.specie_name = specie_name
        this.breed_name = breed_name
        this.color_name = color_name
        this.req_date = req_date
        this.link_no = link_no
        this.link_type = link_type
        this.status = status
        this.unit = unit
        this.cost = cost 
    }
}
